import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { StyledTabs, StyledTab } from 'components/Shared/StyledTabs';
import Loader from 'components/Shared/Loader';

import InfosLogistiqueContainer from './InfosLogistiqueContainer';

/**
 * Englobe l'onglet logistique : pour un dossier créé depuis une commande (plusieurs BL),
 * affiche une barre d'onglets (un par BL) et recharge les infos du BL sélectionné.
 * Pour un BL unique (ou dossier hors commande), aucun onglet : rendu identique à l'existant.
 */
class InfosLogistiqueOnglets extends React.Component {

    state = {
        chargee: false,        // liste des BL chargée ?
        bonsLivraison: [],
        pieceCleActif: null     // n'est défini QUE en multi-BL ; null = défaut backend (1ère pièce)
    };

    componentDidMount() {
        this.chargerBonsLivraison();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.reclamationId !== this.props.reclamationId) {
            this.setState({ chargee: false, bonsLivraison: [], pieceCleActif: null }, this.chargerBonsLivraison);
        }
    }

    chargerBonsLivraison = async () => {
        try {
            const response = await axios.get(`api/reclamations/${this.props.reclamationId}/bons-livraison`);
            const bonsLivraison = response.data || [];
            this.setState({
                chargee: true,
                bonsLivraison,
                // pieceCle explicite seulement s'il y a plusieurs BL ; sinon null = comportement historique strict.
                pieceCleActif: bonsLivraison.length > 1 ? bonsLivraison[0].pieceCle : null
            });
        } catch (error) {
            console.error('InfosLogistiqueOnglets.chargerBonsLivraison : ', error);
            this.setState({ chargee: true, bonsLivraison: [], pieceCleActif: null });
        }
    };

    handleChangeOnglet = (event, pieceCle) => {
        this.setState({ pieceCleActif: pieceCle });
    };

    renderLibelleOnglet = (bl) => {
        // NumeroPiece + NumeroPreparation en sous-texte, sauf s'ils sont identiques (cas Gescom).
        const memeValeur = bl.numeroPiece === bl.numeroPreparation;
        return (
            <Box>
                <Typography variant="body2" sx={{ fontWeight: 'bold' }}>{bl.numeroPiece}</Typography>
                {!memeValeur && bl.numeroPreparation && (
                    <Typography variant="caption" color="text.secondary">{bl.numeroPreparation}</Typography>
                )}
            </Box>
        );
    };

    render() {
        const { reclamationId } = this.props;
        const { chargee, bonsLivraison, pieceCleActif } = this.state;

        // On attend la liste des BL pour ne monter le container qu'une fois (évite un double fetch
        // null → 1ère clé en multi-BL). Loader le temps de l'appel bons-livraison.
        if (!chargee) {
            return <Loader />;
        }

        // 0 ou 1 BL : pas d'onglet, rendu identique à aujourd'hui (pieceCle null = défaut backend).
        if (bonsLivraison.length <= 1) {
            return <InfosLogistiqueContainer reclamationId={reclamationId} pieceCle={null} />;
        }

        return (
            <Box>
                <StyledTabs
                    value={pieceCleActif}
                    onChange={this.handleChangeOnglet}
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={{ mb: 1, borderBottom: 1, borderColor: 'divider' }}
                >
                    {bonsLivraison.map(bl => (
                        <StyledTab key={bl.pieceCle} value={bl.pieceCle} label={this.renderLibelleOnglet(bl)} />
                    ))}
                </StyledTabs>

                <InfosLogistiqueContainer reclamationId={reclamationId} pieceCle={pieceCleActif} />
            </Box>
        );
    }
}

InfosLogistiqueOnglets.propTypes = {
    reclamationId: PropTypes.number.isRequired
};

export default InfosLogistiqueOnglets;
